// @i18n-ignore-file
import QuinceApiError from '@src/quince-site-common/src/domains/quince-api-error'
import { useStatsigClient } from '@statsig/react-bindings'

/**
 * Hook to access Statsig dynamic configuration values
 * @param key - The key of the dynamic configuration to access
 * @returns The configuration value or null if not found/error occurs
 */
export const useStatsigDynamicConfig = (key: string) => {
  const { getDynamicConfig } = useStatsigClient()
  try {
    return getDynamicConfig('ecomm-ssr').get(key)
  } catch (error) {
    // Create and throw the error to be handled by error boundaries
    throw new QuinceApiError({
      apiName: 'Get Statsig Config',
      message: 'Failed while getting statsig config',
      error: error as Error,
    })
  }
}
